import { App, AppLevel } from './types'

const order: Record<AppLevel, number> = {
  'built-in': 1,
  preferred: 2,
  recommended: 3,
  regular: 4,
  '': Infinity,
}

export const mergeAppsData = <R extends { appDefId?: string; type?: string; level?: AppLevel }, C extends App>(
  recommendedApps: R[],
  contentApps: C[],
): App[] => {
  let apps = recommendedApps.reduce((prev: (App & { optionIndex: number })[], recommendedApp: R) => {
    const { appDefId, level, type: appType } = recommendedApp

    if (!appDefId) {
      return prev
    }

    const optionIndex = contentApps.findIndex(
      o => o.appDefId === appDefId || o.optionKey.toLowerCase() === appType?.toLowerCase(),
    )
    const contentApp = contentApps[optionIndex]

    if (!contentApp) {
      return prev
    }

    prev = [
      ...prev,
      {
        appDefId: contentApp.appDefId || appDefId,
        level: (contentApp.level || level || 'regular') as AppLevel,
        name: contentApp.name,
        description: contentApp.description,
        icon: contentApp.icon,
        optionIndex,
        optionKey: contentApp.optionKey,
        biSlug: contentApp.biSlug || contentApp.optionKey,
      },
    ]

    return prev
  }, [])

  apps = apps.sort((a, b) => {
    const aOrder = order[a.level] || Infinity
    const bOrder = order[b.level] || Infinity

    if (aOrder === bOrder) {
      return a.optionIndex - b.optionIndex
    }

    return aOrder - bOrder
  })

  return apps.map(app => {
    const { optionIndex, ...rest } = app

    return rest
  })
}
